import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useState } from 'react';
import '../../styles//Navbar.css';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav className="navbar">
      <a className="navbar-logo" href="/">
        <img src="/buddy_boonzie.svg" alt="Logo" className="navbar-logo-img" />
      </a>

      <div className="hamburger" onClick={toggleMenu}>
        <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
        <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
        <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
      </div>

      <div className={`navbar-links ${menuOpen ? 'active' : ''}`}>
        {user ? (
          <>
            <a href="/">FIND BUDDY</a>
            <a href="/dashboard/home">DASHBOARD</a>
            <a onClick={handleLogout} className="navbar-profile-dropdown-item">
              LOGOUT
            </a>
            <a href="/profile">
              <svg
                width="34"
                height="34"
                viewBox="0 0 34 34"
                fill="none"
                stroke="#FABA59"
                strokeWidth="2"
                className="profile-icon"
              >
                <circle cx="17" cy="17" r="15" />
                <circle cx="17" cy="14" r="6" />
                <path d="M9 27c3-4 13-4 16 0" />
              </svg>
            </a>
          </>
        ) : (
          <>
            <a href="/signup">SIGN UP</a>
            <a href="/">FIND BUDDY</a>
            <a href="/login">LOG IN</a>
          </>
        )}
      </div>
    </nav>
  );
}
